import { createSelector } from 'reselect';
import { AUTH_TYPE } from '../../constants/global';

const organizationSelector = (globalState) => globalState.get('organization');
const authMethodsSelector = (state) => organizationSelector(state).get('authMethods');
const roomsSelector = (state) => organizationSelector(state).get('rooms');
const devicesSelector = (state) => organizationSelector(state).get('devices');
// Organization's info
const organizationIdSelector = (state) => organizationSelector(state).get('_id');
const organizationNameSelector = (state) => organizationSelector(state).get('name');

// Selectors
const makeSelectOrganization = () => createSelector(organizationSelector, (state) => state.toJS());

const makeSelectOrganizationId = () => createSelector(organizationIdSelector, (state) => state);

const makeSelectAuthMethods = () => createSelector(authMethodsSelector, (state) => state.toJS());

const makeSelectRooms = () => createSelector(roomsSelector, (state) => state.toJS());

const makeSelectDevices = () => createSelector(devicesSelector, (state) => state.toJS());

const makeSelectOrganizationName = () => createSelector(organizationNameSelector, (state) => state);

const makeSelectAuthMethodCas = () =>
  createSelector(authMethodsSelector, (state) => {
    const authCas = state.find((method) => method.get('type') === AUTH_TYPE.CAS);
    if (authCas !== undefined) return authCas.toJS();
    return undefined;
  });

export default {
  makeSelectOrganization,
  makeSelectOrganizationId,
  makeSelectAuthMethods,
  makeSelectRooms,
  makeSelectDevices,
  makeSelectAuthMethodCas,
  makeSelectOrganizationName,
};
